import { jsxs as c, jsx as s } from "react/jsx-runtime";
import { c as r } from "../../../index-CvSFHqCB.js";
import * as f from "react";
import { c as a } from "../../../utils-BOFVZgHd.js";
const m = r(
  "grid gap-4 w-full rounded-lg min-h-[100px] border border-[var(--border)] bg-[var(--card)] text-[var(--card-foreground)] shadow-sm transition-colors duration-200",
  {
    variants: {
      size: {
        default: "p-4",
        sm: "p-3",
        lg: "p-6"
      },
      variant: {
        default: "",
        secondary: "bg-[var(--secondary)] text-[var(--secondary-foreground)]",
        ghost: "border-none shadow-none bg-transparent"
      }
    },
    defaultVariants: {
      size: "default",
      variant: "default"
    }
  }
), u = r(
  "font-semibold leading-none tracking-tight text-[var(--card-foreground)]",
  {
    variants: {
      size: {
        default: "text-xl",
        sm: "text-lg",
        lg: "text-2xl"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), g = r("text-[var(--muted-foreground)]", {
  variants: {
    size: {
      default: "text-sm mt-2",
      sm: "text-xs mt-1.5",
      lg: "text-base mt-3"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), v = f.forwardRef(
  ({ className: o, children: i, label: e, description: n, size: t, variant: d }, l) => /* @__PURE__ */ c(
    "div",
    {
      ref: l,
      className: a(
        m({ size: t, variant: d }),
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]",
        o
      ),
      children: [
        e && /* @__PURE__ */ s("h2", { className: a(u({ size: t }), "mb-2 text-foreground"), children: e }),
        n && /* @__PURE__ */ s("p", { className: a(g({ size: t }), "mb-4"), children: n }),
        i
      ]
    }
  )
);
v.displayName = "Container";
export {
  v as Container,
  m as containerVariants
};
//# sourceMappingURL=index.js.map
